import React, { useEffect, useState, useRef, useMemo } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom";
import moment from "moment";
import EasyGrid from "../../client/components/EasyGrid";

function escapeHtml(str = "") {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

const formatTruncate = (value) => {
  let num = Math.round(value);
  const truncated = Math.floor(num * 1000) / 1000;

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  }).format(truncated);
};

const PlbyHierarchicalPopup = ({ data }) => {
  const plusList = Object.values(data?.plus_array || {});
  const minusList = Object.values(data?.minus_array || {});

  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState(10);

  const handleUserClick = async (user) => {};

  const cols = useMemo(
    () => [
      {
        title: "Name",
        data: "uname",
        responsivePriority: 1,
        render: function (d, type, row) {
          const transId = escapeHtml(String(row.transDetailsId ?? ""));

          const role = Number(row.user_role);
          let url;
          if (role == 8) {
            if (data.game_type == 9) {
              url = `/client-virtual-details-view/${transId}`;
            } else if (data.game_type == 6) {
              url = `/client-casino-details-view/${transId}`;
            } else if (data.game_type == 7 || data.game_type == 10) {
              url = `/client-tp-details-view/${transId}`;
            } else {
              url = `/clinet-bet-details-view/${transId}`;
            }
          } else {
            if (data.game_type === 7 || data.game_type === 9) {
              url =
                role === 8 ? `/virtual-details-view/${transId}` : `${transId}`;
            } else {
              url = role === 8 ? `/bet-details-view/${transId}` : `${transId}`;
            }
          }

          return `
          <a href="${url}" 
             style="color:#00b181;cursor:pointer" class="site_family">
             ${d}
          </a>
        `;
        }
      },

      {
        title: "Amount",
        data: "winAmount",
        responsivePriority: 2,
        render: function (d) {
          const val = Number(d ?? 0).toFixed(2);
          const color = val < 0 ? "red" : "green";

          return `
          <span style="color:${color};font-weight:600;" class="site_family">
            ${formatTruncate(val)}
          </span>
        `;
        }
      },
      {
        title: "Trans ID",
        data: "transDetailsId",
        visible: false,
        searchable: false,
        orderable: false
      },
      {
        title: "User Role",
        data: "user_role",
        visible: false,
        searchable: false,
        orderable: false
      }
    ],
    []
  );

  const plusTotal = plusList.reduce(
    (sum, item) => sum + (item.winAmount || 0),
    0
  );
  const minusTotal = minusList.reduce(
    (sum, item) => sum + (item.winAmount || 0),
    0
  );

  useEffect(() => {
    setIsLoading(false);
  }, [data]);

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header">
          <button
            type="button"
            className="btn btn-sm btn-primary site_family"
            onClick={() => window.history.back()}
          >
            Back
          </button>
          <strong class="site_family"> {data?.remark} </strong>
          <span
            className="badge badge-warning site_family"
            style={{ fontSize: "100%" }}
          >
            {data?.uname}{" "}
          </span>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-6">
              <EasyGrid
                responsiveMode="hybrid"
                cols={cols}
                dataset={plusList}
                isLoading={isLoading}
                pageSize={pageSize}
                handleUserClick={handleUserClick}
                ordering={false}
              ></EasyGrid>
            </div>
            <div className="col-6">
              <EasyGrid
                responsiveMode="hybrid"
                cols={cols}
                dataset={minusList}
                isLoading={isLoading}
                pageSize={pageSize}
                handleUserClick={handleUserClick}
                ordering={false}
              ></EasyGrid>
            </div>
            <div className="col-6">
              <table className="table table-sm">
                <tbody>
                  <tr className="">
                    <th className="site_family" style={{ fontWeight: "bold" }}>
                      Total
                    </th>
                    <th className="position-plus site_family">
                      <span style={{ color: "green" }}>
                        {formatTruncate(plusTotal)}
                      </span>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-6">
              <table className="table table-sm">
                <tbody>
                  <tr className="">
                    <td className="site_family" style={{ fontWeight: "bold" }}>
                      Total
                    </td>
                    <th className="position-minus site_family">
                      <span style={{ color: "red" }}>
                        {formatTruncate(minusTotal)}
                      </span>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlbyHierarchicalPopup;
